import { FavoritesListItem } from './favoritesListItem';
import { createMarkup } from "../../utils/createMarkup";

export class FavoritesList {
  _favorites = [];
  favListParentEl = document.querySelector('[data-offcanvas="favorites"] .offcanvas__content');
  favListEl = document.querySelector('.js-favs-list');
  favAddBtn;

  constructor(favorites) {
    this._favorites = favorites;

    this.favAddBtn = document.querySelector('.js-favs-add');
    if (this.favAddBtn) {
      this.favAddBtn.addEventListener('click', () => {
        this._toggle();
      });
    }

    // If using multiples tabs to add/remove favorites, we have to use the `storage` event.
    window.addEventListener('storage', (event) => {
      if (event.key === 'favorites') {
        const isStorageBigger = JSON.parse(event.newValue).length > JSON.parse(event.oldValue).length;
        const favoritesInStorage = localStorage.getItem('favorites').toString();
        this._favorites = JSON.parse(favoritesInStorage);

        if (isStorageBigger) {
          const favoriteToAdd = this._favorites[this._favorites.length - 1];
          const newFavorite = new FavoritesListItem(favoriteToAdd);
          newFavorite.prependTo(this.favListEl);

          if (this.favAddBtn?.dataset.itemId === favoriteToAdd.id) {
            this.favAddBtn.classList.add('active');
          }
        } else {
          // We also have to remove the deleted favorite from the DOM, so we need to compare the old & new values
          // To get the correct `id` to remove
          const oldFavoritesID = JSON.parse(event.oldValue).map((obj) => obj.id);
          const newFavoritesID = JSON.parse(event.newValue).map((obj) => obj.id);
          const removedID = oldFavoritesID.filter((element) => !newFavoritesID.includes(element));

          this.remove(removedID[0])

          if (newFavoritesID.length < 1) {
            this._createAlert();
          }
        }

        this._count();
      }
    })
  }

  init() {
    for (const favorite of this._favorites) {
      const newFavorite = new FavoritesListItem(favorite);
      newFavorite.appendTo(this.favListEl);

      if (this.favAddBtn?.dataset.itemId === favorite.id) {
        this.favAddBtn.classList.add('active');
      }
    }

    this._count();

    this.favListEl.addEventListener('delete', ({ detail: favorite }) => {
      this._favorites = this._favorites.filter((item) => {
        return item !== favorite;
      });
      if (this.favAddBtn?.dataset.itemId === favorite.id) {
        this.favAddBtn.classList.remove('active');
      }
      this._handleUpdate();
    });

    if(this._favorites.length < 1) {
      this._createAlert();
    }
  }

  _toggle() {
    const favoriteTplEl = document.querySelector('.js-favs-item-datas');
    const favoriteTplCol = favoriteTplEl.content.firstElementChild.cloneNode(true);
    const card = favoriteTplCol.querySelector('.card');
    const id = card.dataset.itemId;
    const img = card.querySelector('.lazy-image img').getAttribute('data-src');
    const title = card.querySelector('.card__link').innerText;
    const link = card.querySelector('.card__link').getAttribute('href');
    const city = card.querySelector('.card__city').innerText;
    const subtitle = card.querySelector('.card__subtitle').innerText;
    const price = card.querySelector('.card__price').innerText;
    const tagEls = card.querySelectorAll('.card__tags .label');
    let tags = [];
    tagEls.forEach((tag) => {
      tags.push(tag.outerHTML);
    });
    const status = card.querySelector('.card__status .label');
    const metaEls = card.querySelectorAll('.card__metas__item');
    let metas = [];
    metaEls.forEach((meta) => {
      metas.push(meta.innerText);
    });

    const favorite = {
      id,
      img,
      title,
      link,
      city,
      subtitle,
      price,
      tags,
      status: status ? status.innerText : '',
      metas,
    };

    const favoriteExists = this._favorites.some((item) => item.id === id);

    if (favoriteExists) {
      this._favorites = this._favorites.filter((item) => item.id !== favorite.id);
      this._handleUpdate();
      this.remove(id);
      this.favAddBtn.classList.remove('active');
    } else {
      const newFavorite = new FavoritesListItem(favorite);
      this.favListEl.prepend(newFavorite.element);
      this._favorites.push(favorite);
      this._handleUpdate();
      this.favAddBtn.classList.add('active');
    }
  }
  _handleUpdate() {
    localStorage.setItem('favorites', JSON.stringify(this._favorites));
    const alert = document.querySelector('[data-offcanvas="favorites"] .callout');
    if (this._favorites.length > 0 && alert) {
      alert.remove();
    } else if (this._favorites.length < 1){
      this._createAlert();
    }
    this._count();
  }

  _createAlert() {
    const alertElement = createMarkup('div', {
      class: 'callout',
      role: 'alert'
    })
    alertElement.innerText = `Vous n'avez pas encore ajouté de bien à vos favoris.`;
    this.favListParentEl.prepend(alertElement);
  }

  remove(id) {
    this.favListEl.querySelector(`[data-item-id='${id}']`).parentNode.remove();
  }

  _count() {
    document.querySelector('.js-favs-count').innerText = this._favorites.length;
  }
}
